// src/pages/TherapistPage/CaseHistory/caseFileApi.js
import api from '../../../services/api';

export const listCases = () => api.get('/case-history/cases');
export const getCase = (caseId) => api.get(`/case-history/cases/${caseId}`);
export const getSections = (caseId) => api.get(`/case-history/cases/${caseId}/sections`);
export const getCompletion = (caseId) => api.get(`/case-history/cases/${caseId}/completion`);
export const getFormSchema = () => api.get('/case-history/form-schema');

export const getSignals = () => api.get('/case-history/signals');
export const getTriage = (caseId) => api.get(`/case-history/cases/${caseId}/triage`);
export const listImpressions = (caseId) => api.get(`/case-history/cases/${caseId}/impressions`);
export const saveImpression = (caseId, body) => api.post(`/case-history/cases/${caseId}/impressions`, body);
export const countersign = (caseId) => api.post(`/case-history/cases/${caseId}/countersign`);
export const overrideHearing = (caseId, category, detail) =>
    api.post(`/case-history/cases/${caseId}/hearing-override`, { category, detail });

export const getConsentForCase = (caseId) => api.get(`/consent/case/${caseId}`);
export const requestWithdrawal = (consentId, reason) =>
    api.post(`/consent/${consentId}/withdrawal-request`, { reason });

export const STATUS_LABEL = {
    draft: 'Being filled in', submitted: 'Awaiting your countersign',
    active: 'Clinical work under way', locked: 'Signed off',
};
